module.exports = __webpack_public_path__ + "static/media/arrow-right-line.b3217e7a.svg";